import axios from "@/axios"

const url = "/api/videos/confrontation-drafts"

class ConfrontationDraftsService {
	async store(body) {
		await axios.post(`${url}`, body)
	}

	async upsert(body) {
		const { data } = await axios.post(`${url}/upsert`, body)
		return data
	}

	async getDrafts() {
		const { data } = await axios.get(`${url}/drafts`)
		return data
	}

	async destroy(id) {
		await axios.delete(`${url}/${id}`)
	}
	async list(params) {
		const { data } = await axios.get(`${url}`, {
			params,
		})
		return data
	}
	async counterDrafts() {
		const { data } = await axios.get(`${url}/counter-drafts`)
		return data
	}

	async listGroups(params) {
		const { data } = await axios.get(`${url}/groups`, {
			params,
		})
		return data
	}
}
export default new ConfrontationDraftsService()
